import { z } from 'zod';

export const CreateDtSchema = z.object({
    candidateId: z.string().nullish().describe('ID du candidat (si applicable)'),
    entityId: z.string().describe("ID de l'entité (candidat ou ressource)"),
    fieldsToEnrich: z.array(z.string()).nullish().describe('Liste des champs à générer ou enrichir'),
    referenceDtId: z.string().nullish().describe('ID du DT de référence pour le style ou le contexte'),
    entityType: z.enum(['candidate', 'resource']).describe("Type d'entité (candidate ou resource)"),
});
export type CreateDtDto = z.infer<typeof CreateDtSchema>;

export const CreateCvSchema = z.object({
    candidateId: z.string().nullish().describe('ID du candidat (si applicable)'),
    entityId: z.string().describe("ID de l'entité (candidat ou ressource)"),
    source: z.string().describe('ID du document ou CV source à analyser'),
    fieldsToEnrich: z.array(z.string()).describe('Liste des champs spécifiques à extraire depuis le CV'),
    referenceDtId: z.string().nullish().describe('ID du DT de référence'),
    entityType: z.enum(['candidate', 'resource']).describe("Type d'entité"),
});
export type CreateCvDto = z.infer<typeof CreateCvSchema>;

export const CreateDtWithAiGenericSchema = z.object({
    entityId: z.string().describe("ID de l'entité ciblée"),
    entityType: z.enum(['candidate', 'resource']).describe("Type d'entité"),
})
export type CreateDtWithAiGeneric = z.infer<typeof CreateDtWithAiGenericSchema>;

export const CreateDtWithAiSchema = CreateDtWithAiGenericSchema.extend({
    candidateId: z.string().nullish().describe('ID du candidat (si applicable)'),
    sources: z.array(z.string()).describe('Liste des sources de données à utiliser pour la génération'),
    fieldsToEnrich: z.array(z.string()).describe('Liste des champs à générer (ex: summary, skills, experience_years, references)'),
    referenceDtId: z.string().nullish().describe('ID du DT de référence'),
    opportunityId: z.string().nullish().describe("ID de l'opportunité (besoin client) ciblée"),
    actionsPeriod: z.number().nullish().describe("Période d'actions à prendre en compte (en mois)"),
    enrichEntitySheet: z.boolean().nullish().describe('Faut-il également enrichir la fiche entité BoondManager ?'),
});
export type CreateDtWithAiDto = z.infer<typeof CreateDtWithAiSchema>;

export const ImproveDtWithAiSchema = z.object({
    entityId: z.string().describe("ID de l'entité concernée"),
    fieldsToEnrich: z.array(z.string()).describe('Liste des champs existants à améliorer ou reformuler'),
});
export type ImproveDtWithAiDto = z.infer<typeof ImproveDtWithAiSchema>;

export const DtAiPartialFailureSchema = z.object({
    retryDtId: z.string().describe('ID de session à utiliser pour relancer les requêtes échouées'),
    failedCount: z.number().describe('Nombre de requêtes IA à relancer'),
    retryCredits: z.number().describe('Crédits disponibles pour la relance'),
    expiresAt: z.union([z.string(), z.date()]).nullish().describe("Date d'expiration de l'état de retry"),
});
export type DtAiPartialFailureDto = z.infer<typeof DtAiPartialFailureSchema>;

export const DtAiGenerationResponseSchema = z.object({
    createdDtId: z.string().optional().describe('ID du DT créé ou mis à jour'),
    fieldsGeneratedByAI: z.record(z.string(), z.unknown()).describe("Champs DT générés par l'IA"),
    entitySheet: z.record(z.string(), z.unknown()).nullish().describe("Fiche entité enrichie par l'IA"),
    partialFailure: DtAiPartialFailureSchema.nullish().describe('État de retry en cas d’échec partiel'),
});
export type DtAiGenerationResponseDto = z.infer<typeof DtAiGenerationResponseSchema>;
